module.exports = __webpack_public_path__ + "img/chris-black.1dd839ef.svg";